<template>
  <div class="aeroView">
    <h2 class="titlePage">Vous pouvez maintenant rejoindre le Gîte d'en Lébé par les airs !</h2>
    <section>
      <img
        src="@/assets/images/aerodrome/avions1.jpg"
        alt="aerodrome gite en lebe vue du ciel"
      />
      <div>
        <h3>Piste LF3260</h3>
        <p>
          <b>Orientation magnétique :</b> 272°/092°
        </p>
        <p>
          <b>Coordonnées :</b>43°40'06'' nord - 000°54'59" est
        </p>
        <p>
          <b>Longueur :</b> 475 m
        </p>
        <p>
          <b>Altitude :</b> 590 ft
        </p>
        <p>
          <b>Tour de piste :</b> main gauche
        </p>
        <p>
          <b>Largeur :</b> 30m
        </p>

        <br />
        <br />
        <p>
          Pour plus d'infos, merci de nous contacter au <a href="tel:0684818881">06 84 81 88 81</a> ou par mail <a href="mailto:enlebegite@gmail.com">enlebegite@gmail.com</a>
        </p>

        <!-- <a href="#teteenlair">
          <h3>Séjour Le Gers , la tête en l'air !</h3>
          <i class="fad fa-arrow-alt-circle-down"></i>
        </a>-->
      </div>
    </section>
    <!-- 
    <article>
      <img
        src="@/assets/images/aerodrome/fiche-aero.jpg"
        alt="aerodrome gite en lebe"
        id="teteenlair"
      />
    </article>-->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  mounted() {},
  watch: {},

  methods: {},
};
</script>

<style>
.aeroView section {
  display: flex;
}
.aeroView section img {
  width: 60%;
  object-fit: cover;
}
.aeroView section > div {
  padding: 2rem;
  width: 40%;
}
.aeroView h2 {
  text-align: center;
  font-size: 2.5rem;
  font-weight: normal;
  color: var(--dark-color);
  margin: 2rem;
  word-spacing: 2px;
}
.aeroView a {
  text-align: center;
}
.aeroView h3 {
  font-size: 2rem;
  font-weight: normal;
  color: var(--dark-color);
  margin: 0rem;
}
.aeroView i {
  margin-top: 1rem;
  font-size: 3em;
  font-weight: normal;
  color: var(--dark-color);
  text-align: center;
  margin-left: 50%;
  transform: translateX(-50%);
}
.aeroView article {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.aeroView article img {
  max-width: 100%;
}

@media all and (max-width: 990px) {
  .aeroView section {
    flex-direction: column;
  }
  .aeroView section img {
    width: 100%;
    max-height: 50vh;
  }
  .aeroView section > div {
    width: 100%;
    padding: 0;
  }
  .aeroView section > div p {
    margin-left: 5%;
  }
}
</style>